export default __webpack_public_path__ + "static/media/xlsx.7d17e770.svg";